import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// import { toAbsoluteUrl } from '../../../_metronic';
import ForgotPassword from './ForgotPassword';
import Registration from './Registration';
import Login from './Login';
import Otp from './Otp';
import Password from './Password';
import { ROUTES } from '../../constants/routes/routes';
// import '../../../_metronic/_assets/sass/pages/login/login-1.scss';

export default function AuthPage () {
    return (
        <>
            <div className="kt-grid kt-grid--ver kt-grid--root">
                <div id="kt_login" className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
                        <div
                            className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                            // style={{ backgroundImage: `url(${toAbsoluteUrl('/media/bg/ObeliscoBA2017.jpg')})` }}
                        />

                        <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
                            <Switch>
                                <Route path={ROUTES.AUTH.LOGIN} component={Login} />
                                <Route path={ROUTES.AUTH.OTP} component={Otp} />
                                <Route path={ROUTES.AUTH.PASSWORD} component={Password} />
                                <Route path={ROUTES.AUTH.REGISTRATION} component={Registration} />
                                <Route path={ROUTES.AUTH.FORGOT_PASSWORD} component={ForgotPassword} />
                                <Redirect from={ROUTES.AUTH.BASE} exact={true} to={ROUTES.AUTH.LOGIN} />
                                <Redirect to={ROUTES.AUTH.LOGIN} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
